export type RuleModificationType = 'created' | 'updated' | 'deleted';

export interface SubmitRuleCell {
  label: string;
  value: string;
  previousValue?: string;
}

export interface SubmitRuleChangeRow {
  id: string;
  modificationType: RuleModificationType;
  cells: SubmitRuleCell[];
}

export interface SubmitRuleCategory {
  importType: string;
  title: string;
  rules: SubmitRuleChangeRow[];
}

export const SUBMIT_RULE_CATEGORIES: SubmitRuleCategory[] = [
  {
    importType: 'actors',
    title: 'Acteurs',
    rules: [
      {
        id: 'actor-1042',
        modificationType: 'updated',
        cells: [
          { label: 'Nom', value: 'Apple Europe SARL', previousValue: 'Apple Europe' },
          { label: 'Type', value: 'Réparateur' },
          { label: 'Pays', value: 'France' },
        ],
      },
      {
        id: 'actor-1088',
        modificationType: 'created',
        cells: [
          { label: 'Nom', value: 'Samsung Service France' },
          { label: 'Type', value: 'Centre de service' },
          { label: 'Pays', value: 'France' },
        ],
      },
    ],
  },
  {
    importType: 'solutions',
    title: 'Solutions',
    rules: [
      {
        id: 'sol-2201',
        modificationType: 'updated',
        cells: [
          {
            label: 'Libellé',
            value: 'Intervention à domicile sous 48h',
            previousValue: 'Intervention à domicile sous 72h',
          },
          { label: 'Code', value: 'IDD_48' },
          { label: 'Actif', value: 'Oui' },
        ],
      },
    ],
  },
  {
    importType: 'warranties',
    title: 'Garanties',
    rules: [
      {
        id: 'war-3305',
        modificationType: 'deleted',
        cells: [
          { label: 'Libellé', value: 'Garantie constructeur 12 mois' },
          { label: 'Durée', value: '12 mois' },
        ],
      },
      {
        id: 'war-3310',
        modificationType: 'created',
        cells: [
          { label: 'Libellé', value: 'Garantie distributeur étendue' },
          { label: 'Durée', value: '24 mois' },
        ],
      },
    ],
  },
  {
    importType: 'reasons',
    title: 'Motifs',
    rules: [],
  },
  {
    importType: 'additionalInformations',
    title: 'Informations complémentaires',
    rules: [
      {
        id: 'info-4402',
        modificationType: 'updated',
        cells: [
          { label: 'Champ', value: 'Numéro de série obligatoire' },
          { label: 'Obligatoire', value: 'Oui', previousValue: 'Non' },
        ],
      },
    ],
  },
  {
    importType: 'transport',
    title: 'Transport',
    rules: [],
  },
];
